import $ from 'jquery';
import enquire from 'enquire.js';

$(() => {
  $('body').on('click', '.main-head .search-trigger', (e) => {
    $(e.target).closest('.main-head').toggleClass('search-open');
    e.preventDefault();
  });

  enquire.register('screen and (max-width:1023px)', {
    match: () => {
      $('.main-head .search-trigger').each(function (e) { // eslint-disable-line no-unused-vars
        $(this).on('click', (e) => { // eslint-disable-line no-shadow
          $(this).closest('.main-head').find('.head-search-panel input').focus();
          e.preventDefault();
        });
      });
    },
  });
});



/** WEBPACK FOOTER **
 ** ./src/js/head-search.js
 **/